export default function activitiesToRedirect(activity) {
    const activitesToRedirect = [
        "accounts.opening",
        "accounts.opening",
        "account.checks",
        "accounts.opening",
        "transfers.internal.send",
        "transfers.internal.tad.send",
        "accounts.opening",
        "transfers.thirdParties.send",
        "transfersCVU.thirdParties.send",
        "transfers.thirdParties.tad.send",
        "transfers.toContact.send",
        "transfersCVU.toContact.send",
        "transfers.toContact.tad.send",
        "accounts.opening",
        "debin.incoming.accept.send",
        "chargeback.recurrency",
        "chargeback.pull",
        "debinCVU.incoming.accept.send",
        "accounts.opening",
        "credin.sentRequest.send",
        "credinCVU.sentRequest.send",
        "endorse.echeq.activity",
        "negotiate.echeq.activity",
        "echeq.admit.action",
        "echeq.repudiate.action",
        "echeq.deposit.action",
        "echeq.custody.action",
        "echeq.rescue.action",
        "pay.multiline.send",
        "payments.makePayment",
        "emit.echeq.activity",
        "external.emit.echeq.activity",
        "echeq.admit-cesion.action",
        "echeq.repudiate-cesion.action",
        "cesion.echeq.activity",
        "echeq.anulate-echeq.action",
        "echeq.anulate-cesion.action",
        "echeq.anulate-endorse.action",
        "echeq.request-return.action",
        "echeq.repudiate-return.action",
        "echeq.anulate-return.action",
        "accept.return.echeqs",
        "echeq.request-certificate.action",
        "load.debin.recurrency",
        "change.status.debin.recurrency",
        "scheduled.transactions.cancel",
        "fundcorp.register.rescue.request",
        "fundcorp.register.suscription.request",
        "emit.massive.echeqs.send",
        "external.emit.massive.echeq.activity",
        "transfer.multiple.send",
        "cedip.reject",
        "ecomex.send.accept.transaction",
        "manage.echeq.rules",
        "send.external.transaction",
        "direct.debit.create.send",
        "mass.echeq.manage.admit.send",
        "mass.echeq.manage.pay.send",
        "fundcorp.cancel.send",
        "temporary.limit.increase.request",
    ];

    return activitesToRedirect.find((object) => object === activity);
}
